// User Request model for user request account  properties
export class UserRequest {
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  jobTitle: string;
  aboutUserField: string;
}
